import React from "react";
import BanksBig from "../../img/banks-big.jpg";
import BanksSmall from "../../img/banks-small.jpg";

function Banks() {
  return (
    <section className="flex flex-col justify-center items-center space-y-8 pt-8 pb-4 xl:pb-32">
      {/* <h3 className="text-2xl font-semibold text-[#244565]">List Of Banks</h3>
      <img
        alt=""
        src={BanksSmall}
        className="md:hidden object-contain w-full"
      />
      <img
        alt=""
        src={BanksBig}
        className="hidden md:flex object-contain md:px-[5%]"
      /> */}
    </section>
  );
}

export default Banks;
